import { render, staticRenderFns } from "./PowerGen.vue?vue&type=template&id=16c71d90"
import script from "./PowerGen.vue?vue&type=script&lang=js"
export * from "./PowerGen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports